module.exports = __webpack_public_path__ + "assets/img/companyicon3.8246656d.jpg";